import { findAJobPaths } from "../routes/find-a-job";
import { enterPrisesPaths } from "../routes/enterprises";
import { useLocation, useNavigate } from "react-router-dom";
import { disconnectSocket } from "../redux/features/chat/socket";
import LogoutConfirmationModal from "../components/Modals/common/webinar/LogoutConfirmationModal";
import { getProfile } from "../utils/pip";

const FreelancerLayout = ({ children, user }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const profileData = getProfile("freelancer") || {};
  const headerImage =
    profileData?.profile_image ||
    profileData?.open_talent?.profile_image ||
    "/assets/img/user_profile.png";
  const composedName = [profileData?.first_name, profileData?.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  const profileName =
    profileData?.full_name ||
    profileData?.open_talent?.full_name ||
    composedName ||
    profileData?.email ||
    "";

  const handleLogout = () => {
    localStorage.removeItem("freelancer_profile_nuvio");
    localStorage.removeItem("freelancer_token_nuvio");
    disconnectSocket();
    navigate(enterPrisesPaths?.Enterprise);
  };

  return (
    <>
      <div class="ct_dash_header ct_px_40">
        <div class="ct_dash_logo">
          <a onClick={() => navigate(enterPrisesPaths?.Enterprise)}>
            <img src="/assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <ul class="ct_right_dash_option">
          <li onClick={() => {
            navigate(findAJobPaths?.Inbox)
          }}>
            <a>
              <i class="fa-solid fa-comment"></i>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-bell"></i>
            </a>
          </li>
          <li>
            <div class="ct_right_dropdown dropdown">
              <button
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div class="d-flex align-items-center">
                  <img
                    src={headerImage}
                    alt=""
                    class="ct_img_30"
                  />
                  {profileName ? <span class="ms-2">{profileName}</span> : null}
                </div>
                <i class="fa-solid fa-angle-down ms-auto"></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a
                    class="dropdown-item"
                    onClick={() => navigate(findAJobPaths?.Profile)}
                  >
                    My Profile
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    onClick={() =>
                      navigate(findAJobPaths?.Settings, {
                        state: { tab: "Security" },
                      })
                    }
                  >
                    Change Password
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_logout_admin"
                  >
                    Log Out
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div class="ct_dash_nav ct_px_40">
        <ul>
          {[
            { label: "Dashboard", route: findAJobPaths?.Dashboard },
            { label: "My Jobs", route: findAJobPaths?.MyJob },
            { label: "My Courses", route: findAJobPaths?.MyCourses },
            { label: "Projects", route: findAJobPaths?.MyProjects },
            { label: "Growth", route: findAJobPaths?.Growth },
            { label: "Profile", route: findAJobPaths?.Profile },
            { label: "Inbox", route: findAJobPaths?.Inbox },
            { label: "Settings", route: findAJobPaths?.Settings },
          ]?.map((item, index) => (
            <li onClick={() => navigate(item?.route)}>
              <a className={pathname == item?.route ? "active" : ""}>
                {item?.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      {children}
      <LogoutConfirmationModal
        id="ct_logout_admin"
        title="Logout"
        onConfirm={handleLogout}
      />
    </>
  );
};

export default FreelancerLayout;

